import { Routes } from '@angular/router';
import { AuthenticationGuardService } from './auth/guards/authentication-guard';
import { EmployeeTabsComponent } from './modules/personnel-files/employee-tabs/employee-tabs.component';
import { ClassicSandboxComponent } from './shared/iframe/components/classic-sandbox/classic-sandbox.component';

export const managerRoutes: Routes = [
  {
    path: 'manager',
    children: [
      {
        path: 'my-team',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 95
        },
      },
      {
        path: 'reports/trainingemployees',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/reports/mdwtrainingreport.asp',
        },
      },
      {
        path: 'my-team/documents',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 11
        },
      },
      {
        path: 'my-team/positions',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/positions/positionsearch.asp?DOTNET=1',
        },
      },
      {
        path: 'my-team/worklist',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/dashboard/udfieldworklist.asp?DOTNET=1',
        },
      },
      {
        path: 'my-team/timeline',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/adm/timeline.asp?DOTNET=1&netfilter=1',
        },
      },
      {
        path: 'goals/development-goals',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 38
        },
      },
      {
        path: 'goals/performance-goals',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          data: { menuId: 4 }
        },
      },
      {
        path: 'compliance',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 3
        },
      },
      {
        path: 'compliance/qualifications',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/certificates/studentcertificates.asp?DOTNET=1',
        },
      },
      {
        path: 'conversations/formal-list',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/teamreviews/viewteamreviews.asp?DOTNET=1',
        },
      },
      {
        path: 'conversations/formal-list/detail',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/EN/common/students/viewstudentdetailreviews.asp',
        },
      },
      {
        path: 'conversations/formal-visual',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/teamreviews/teamgesprekken.asp?DOTNET=1',
        },
      },
      {
        path: 'conversations/individual',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 39
        },
      },
      {
        path: 'conversations/formal-dashboard',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/dashboard/home.asp?DOTNET=1&frompage=mgr',
        },
      },
      {
        path: 'conversations/informal',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 90
        },
      },
      {
        path: 'conversations/ad-hoc',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 36
        },
      },
      {
        path: 'conversations/employeeoverview',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 39
        },
      },
      {
        path: 'skillsoverview',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 295
        },
      },
      {
        path: 'development/planning-team',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/courses/planning.asp?DOTNET=1&status=1',
        },
      },
      {
        path: 'development/planning-individual',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/sharedmenus/mainpages/teamschedule.asp?DOTNET=1',
        },
      },
      {
        path: 'development/individual-requests',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 16
        },
      },
      {
        path: 'development/current-courses',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 15
        },
      },
      {
        path: 'development/registration-adhoc',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/createncc.asp?fromstu=3&DOTNET=1&linkhit=1',
        },
      },
      {
        path: 'development/registration-groups',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/sharedmenus/mainpages/teamcoursegroups.asp?DOTNET=1',
        },
      },
      {
        path: 'development/finished-courses',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          menuId: 17
        },
      },
      {
        path: 'tasks/courserequests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/waitlistsearch.asp?DOTNET=1&selectedapprovalstage=1&applyfilter=1&chkApprovalPending=on&chkApproved=&chkCCD=on&chkCCWD=on&chkNCC=on&chkElearning=on',
        },
      },
      {
        path: 'development/requests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/waitlistsearch.asp?DOTNET=1&selectedapprovalstage=0&applyfilter=1&chkApprovalPending=on&chkApproved=&chkCCD=on&chkCCWD=on&chkNCC=on&chkElearning=on',
        },
      },
      {
        path: 'development/learningpaths',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/waitlistsearch.asp?DOTNET=1',
        },
      },
      {
        path: 'development/ncccourses',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/waitlistsearch.asp?DOTNET=1',
        },
      },

      {
        path: 'knowledge-domains',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/teamcompetencies/teamcompetencies.asp?fillvar=1&student=0&indirrep=0&DOTNET=1',
        },
      },
      {
        path: 'knowledge-domains-reports',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/EN/common/competencies/exportclusters.asp?indirrep=0&DOTNET=1',
        },
      },
    ],
    canActivate: [AuthenticationGuardService],
  },
];
